import { Flex } from "@chakra-ui/react";
import * as React from "react";

export default function Sidebar({ children }: { children: React.ReactNode }) {
  return (
    <Flex
      bg="navy"
      borderRadius="xl"
      direction="column"
      display={{ base: "none", md: "flex" }}
      flexShrink="0"
      m="1"
      overflow="hidden"
      w={"240px" as any}
    >
      {children}
    </Flex>
  );
}
